// extracted by mini-css-extract-plugin
module.exports = {"column":"propertyOptions_column__259Q-","columnsMobile":"propertyOptions_columnsMobile__g5Twn","title":"propertyOptions_title__2C2DN","columns":"propertyOptions_columns__2Hoe9","collapse":"propertyOptions_collapse__3NLp9"};
    if(module.hot) {
      // 1745223432245
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  